import { defineNuxtRouteMiddleware, navigateTo } from "nuxt/app";
import { RouteLocationNormalized } from "vue-router";
import { FilterType } from "@domain/enums/FilterType";
import { countryGetIsoCode } from "@studyportals/static-domain-data/countries/country-get-iso-code";

export default defineNuxtRouteMiddleware((to: RouteLocationNormalized) => {
	if(typeof to.query?.[FilterType.COUNTRY] === 'undefined') return;
	const identifiers = (to.query[FilterType.COUNTRY] as string).split(',');

	let hasChangedIso = false;

	const isoCodes = [];
	for(const identifier of identifiers){
		if(isNaN(Number(identifier))) {
			isoCodes.push(identifier)
			continue;
		}

		const iso = countryGetIsoCode(identifier);
		if(iso) {
			isoCodes.push(iso)
			hasChangedIso = true;
		}
	}

	if(!hasChangedIso) return;

	to.query[FilterType.COUNTRY] = isoCodes.join(',');
	return navigateTo(to, { replace: true });
});
